import { Modal, ModalContent, ModalRoot } from '@utilitywarehouse/hearth-react';

import { EnergyBreakdown } from '@components/EnergyBreakdown';
import { EnergyTile, EnergyTileProps } from '@components/ServiceTile';
import { EnergyFuelType, EnergyQuote } from '@generated/gql/graphql';
import { useSyncState } from '@hooks/useSyncState';

interface EnergyTariffTileProps extends EnergyTileProps {
  quote: EnergyQuote;
  fuelType: EnergyFuelType;
}

const EnergyTariffTile = (props: EnergyTariffTileProps) => {
  const [breakdownOpen, setBreakdownOpen] = useSyncState(
    `${props.quote.name}-breakdown-opened`,
    false
  );

  return (
    <ModalRoot open={breakdownOpen} onOpenChange={setBreakdownOpen}>
      <EnergyTile
        {...props}
        breakdown={{
          variant: 'button',
          label: 'Tariff breakdown',
          onClick: () => setBreakdownOpen(true),
        }}
      />
      <Modal loading={false} heading="" hideCloseButton={false} fullScreen>
        <ModalContent>
          <EnergyBreakdown quote={props.quote} fuelType={props.fuelType} />
        </ModalContent>
      </Modal>
    </ModalRoot>
  );
};

export { EnergyTariffTile };
